import request from '@/axios/http'

// 充值账户余额
export function balance (data) {
	return request({
		url: '/stage-api/recharge/balance',
		method: 'post',
		data
	})
}


// 消费记录
export function consumptionRecord (params) {
	return request({
		url: '/stage-api/recharge/consumption-record',
		method: 'get',
		params
	})
}


// 充值统计
export function count (data) {
	return request({
		url: '/stage-api/recharge/count',
		method: 'get',
		data
	})
}
// 充值记录
export function record (params) {
	return request({
		url: '/stage-api/recharge/record',
		method: 'get',
		params
	})
}
// 新增提现
export function settle (data) {
	return request({
		url: '​/stage-api​/pay​/settle',
		method: 'post',
		data
	})
}
// 提现记录
export function settlelList (params) {
	return request({
		url: '/stage-api/pay/settle/plist',
		method: 'get',
		params
	})
}

// 提现账户配置
export function settleConfig_addAccount (data) {
	return request({
		url: '/stage-api/pay/settle-config/addAccount',
		method: 'post',
		data
	})
}

// 根据用户查询提现账户配置详情
export function settleConfig_querySettleInfo (params) {
	return request({
		url: '/stage-api/pay/settle-config/querySettleInfo',
		method: 'get',
		params
	})
}

// 申请提现
export function settle_apply (data) {
	return request({
		url: '/stage-api/pay/settle/apply',
		method: 'post',
		data
	})
}


// 修改提现账号
export function settle_updateAccount (data) {
	return request({
		url: '/stage-api/pay/settle-config/updateAccount',
		method: 'post',
		data
	})
}



